import { createAction } from '@reduxjs/toolkit';
import { ShortcutAction } from '../../actions/action-types';
import { detailTogglePHI, openWindow } from '../../actions/ui';
import { toggleForcePasswordOption } from '../../actions/users';
import { showProcessingTimeline } from '../../actions/cases.action';
import { caseDetailPopup } from '@codametrix/shared-views';
const passthrough = (object)=>object;
const noActionDefined = createAction(ShortcutAction.NOT_FOUND);
export const KeypressTransformers = {
    detailTogglePHI: (mask)=>{
        const active = !mask.active;
        return {
            ...mask,
            active
        };
    },
    showCaseJSON: (info)=>{
        const params = {
            caseId: info.case_id
        };
        return {
            ...caseDetailPopup,
            params
        };
    },
    toggleForcePasswordOption: (info)=>{
        const active = !info;
        return active;
    },
    showProcessingTimeline: (info)=>{
        const active = !info;
        return active;
    }
};
export const ShortcutActions = {
    detailTogglePHI: detailTogglePHI,
    showCaseJSON: openWindow,
    toggleForcePasswordOption: toggleForcePasswordOption,
    showProcessingTimeline: showProcessingTimeline
};
export const fetch = (key)=>{
    const transformer = KeypressTransformers[key] || passthrough;
    const action = ShortcutActions[key] || noActionDefined;
    return {
        transformer,
        action
    };
};
